export const TRACKING_STATUS = {
  CANCELED: 'CANCELED',
  COLLECTED: 'COLLECTED',
  DELIVERED: 'DELIVERED',
  IN_INTERRUPTED_ROUTE: 'IN_INTERRUPTED_ROUTE',
  IN_ROUTING: 'IN_ROUTING',
  IN_SERVICE_POINT: 'IN_SERVICE_POINT',
  IN_TREATMENT: 'IN_TREATMENT',
  NOT_COLLECTED: 'NOT_COLLECTED',
  NOT_DELIVERED: 'NOT_DELIVERED',
  PROCESSING: 'PROCESSING',
  RETURNED: 'RETURNED'
};

export const TRACKING_STATUS_AVAILABLE_TO_CREATE_REQUEST = [
  TRACKING_STATUS.IN_ROUTING,
  TRACKING_STATUS.NOT_COLLECTED,
  TRACKING_STATUS.NOT_DELIVERED,
  TRACKING_STATUS.PROCESSING
];
